import React from 'react'
import Footer from '../components/Footer'
import Header from '../components/Header'

const WebsiteLayout = ({children, isAdmin = false, onAdminAction = null, adminActionText = null}) => {
  return (
    <>
    <Header isAdmin={isAdmin} onAdminAction={onAdminAction} adminActionText={adminActionText}/>
    <div id="sb-dynamic-content" className="sb-transition-fade">
        {children}
        <Footer/>
    </div>

    </>
  )
}

export default WebsiteLayout